import React,{useState} from "react"
import "./Hero.css"
import illustration1 from "../images/illustration-1.svg"
const Hero = () => {
    const [input, setInput] = useState("")
    return (
        <section className="hero">
            <div className="container px">
                <div className="flex">
                    <div className="hero__image">
                    <img src={illustration1} alt=""/>
                    </div> 
                    <div className="hero__text">
                         <h1>All your files in one secure location, accessible anywhere.
                        </h1>
                        <h6>Fylo stores your most important files in one secure location. Access them wherever you need,share and collaborate with friends, family, and co-workers.</h6> 
                        <form action="">
                           
                            <input type="text" placeholder="Enter Your Mail....." value={input}  />
                            
                           
                                <button className="hero__button"> Get Started</button>
                              
                    </form>
                </div>
                </div>
                
            </div>
        </section>
    )
}

export default Hero
